module.exports = __webpack_public_path__ + "img/icon-binoculars-light-gray.7388e88c.svg";